
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"16","viewBox":"0 0 24 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M1.847 10.897c.144.068.303.1.462.094l.314-.012c.38-.015.72.204.995.467.359.343.846.554 1.382.554.59 0 1.121-.256 1.488-.663.254-.283.577-.527.957-.541l8.767-.333c.483-.018.89.335 1.178.724a2 2 0 003.527-.614c.049-.165.188-.296.36-.302a.356.356 0 00.2-.071l1.424-1.068a1 1 0 00.349-1.116l-.705-2.114a.463.463 0 01.183-.532l.055-.037a.443.443 0 00-.443-.764l-.672.336A1 1 0 0121.08 5l-6.87-.981a1 1 0 00-.265-.002l-3.898.487a1 1 0 00-.282.078L5.2 6.611 1.393 8.515a1 1 0 00-.502.578l-.11.33a1 1 0 00.525 1.221l.541.253zm6.582-4.533l1.938-.775a.501.501 0 01.114-.03l3.392-.485a.5.5 0 01.37.095l.89.667a.5.5 0 01-.253.898l-6.218.592c-.575.054-.769-.748-.233-.962zm8.649.147l-1.353-1.015c-.164-.123-.059-.384.145-.358l3.38.422a.5.5 0 01.097.022l1.917.64c.215.071.164.389-.063.389h-3.823a.5.5 0 01-.3-.1z","fill":"currentColor"}})])
          )
        }
      }
    